import { render, staticRenderFns } from "./custom-image.vue?vue&type=template&id=bf3927ca"
import script from "./custom-image.vue?vue&type=script&lang=ts"
export * from "./custom-image.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports